import type { ComponentProps, ComponentType, PropsWithChildren, ReactNode } from "react";

type ProviderProps = {
  children: ReactNode;
};

type ProviderWithProps<T extends ComponentType<any>> = [T, Omit<ComponentProps<T>, "children">];

type SimpleProvider = ComponentType<ProviderProps>;

type Provider = SimpleProvider | ProviderWithProps<any>;

type ProviderComposerProps = {
  providers: Provider[];
};

export function ProviderComposer({
  providers,
  children
}: PropsWithChildren<ProviderComposerProps>) {
  return providers.reduceRight((acc, provider) => {
    if (Array.isArray(provider)) {
      const [ProviderComponent, props] = provider;
      return <ProviderComponent {...props}>{acc}</ProviderComponent>;
    }

    const ProviderComponent = provider;
    return <ProviderComponent>{acc}</ProviderComponent>;
  }, children);
}

export function composeProvider<T extends ComponentType<any>>(
  ProviderComponent: T,
  props: Omit<ComponentProps<T>, "children">
): ProviderWithProps<T> {
  return [ProviderComponent, props];
}
